import { Link } from "react-router-dom";
import type { MvItem } from "@/types/mv";
import { formatViews } from "@/utils/format";

export default function MvCard({ mv }: { mv: MvItem }) {
  return (
    <Link
      to={`/detail/${mv.id}`}
      className="group block overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-colors hover:border-primary-500/60"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={mv.cover}
          alt={`${mv.title} 封面 - ${mv.artist} MV`}
          title={`${mv.title} - ${mv.artist} MV`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
        <span className="absolute right-2 top-2 rounded bg-background-950/70 px-2 py-0.5 text-xs text-foreground-200">
          {mv.duration}
        </span>
        <span className="absolute bottom-2 left-2 flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/90 text-xl text-background-950 opacity-0 transition-opacity group-hover:opacity-100">
          <i className="ri-play-fill" aria-hidden="true"></i>
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-100 transition-colors group-hover:text-primary-400">
          {mv.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-400">{mv.artist}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{mv.releaseDate}</span>
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line" aria-hidden="true"></i>
            {formatViews(mv.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}